import { MutableRefObject } from 'react'
import { NavigationRouteConfig } from '@src/utils/analytics'

export const useScreenCaptureTracking = (
  _routeNameRef: MutableRefObject<NavigationRouteConfig['name'] | null>,
) => {}
